import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../contexts/LanguageContext';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const TestPage = () => {
  const { t } = useTranslation();
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedBooks, setExpandedBooks] = useState({});
  const [searchParams] = useSearchParams();
  const { currentLanguage } = useLanguage();

  useEffect(() => {
    const selectedBookId = searchParams.get('bookId');
    fetchBooks(selectedBookId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, currentLanguage]);  // ?�어 변�????�로??

  const fetchBooks = async (bookId) => {
    try {
      if (bookId) {
        const response = await axios.get(`${API_BASE_URL}/api/books/${bookId}?language=${currentLanguage}`);
        setBooks([response.data]);
      } else {
        const response = await axios.get(`${API_BASE_URL}/api/books/?language=${currentLanguage}&limit=100`);
        setBooks(response.data);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching books:', error);
      setLoading(false);
    }
  };

  // v2: ?�벨�??�즈 ?�작 (set_id?� level_tag 모두 ?�달)
  const startQuizWithLevel = (bookId, setId, levelTag) => {
    const token = localStorage.getItem('token');
    const userType = localStorage.getItem('userType');
    
    if (token && userType === 'student') {
      window.location.href = `/quiz/${bookId}/${setId}?level=${levelTag}`;
    } else {
      window.location.href = `/quiz/${bookId}/${setId}?guest=true&level=${levelTag}`;
    }
  };
  
  // v2: ?�위 ?�환???��? (?�벨 ?�이 ?�트�?
  const startQuizWithSet = (bookId, setId) => {
    startQuizWithLevel(bookId, setId, null);
  };

  // v2: ?�위 ?�환???��? (?�용?��? ?�음, ?�거 ?�정)
  const startQuiz = (bookId, setId) => {
    startQuizWithSet(bookId, setId);
  };

  const toggleDescription = (bookId) => {
    setExpandedBooks(prev => ({
      ...prev,
      [bookId]: !prev[bookId]
    }));
  };

  if (loading) {
    return (
      <div className="container">
        <div className="loading-center">
          <div className="loading-spinner"></div>
          <p>{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="page-header">
        <h1>{t('test.title')}</h1>
      </div>

      {books.length === 0 ? (
        <div className="empty-state">
          <h3>{t('test.noBooksAvailable')}</h3>
          <p>{t('test.noBooksDescription')}</p>
        </div>
      ) : (
        <div className="books-grid">
          {books.map((book, index) => (
            <div key={book.id} className="card">
              <div className="book-info">
                {/* �??�목, 리소??배�?, + 버튼???�함?�는 ?�더 ?�역 */}
                <div className="book-header" style={{ 
                  position: 'relative', 
                  display: 'flex', 
                  flexDirection: 'column', 
                  gap: '0.5rem',
                  justifyContent: 'flex-start',
                  alignItems: 'stretch',
                  marginBottom: '10px'
                }}>
                  {/* �??�목 - 가?�데 ?�렬 */}
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <h3 style={{ margin: 0 }}>{book.title}</h3>
                  </div>
                  
                  {/* 리소??배�? (?�릭 가?? - 가?�데 ?�렬 */}
                  <div style={{ display: 'flex', gap: '0.25rem', alignItems: 'center', justifyContent: 'center' }}>
                    {book.original_link && (
                      <a
                        href={book.original_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={t('test.viewOriginal')}
                        onClick={(e) => e.stopPropagation()}
                        style={{
                          fontSize: '1rem',
                          padding: '0.2rem 0.4rem',
                          backgroundColor: '#dbeafe',
                          borderRadius: '6px',
                          display: 'inline-flex',
                          alignItems: 'center',
                          cursor: 'pointer',
                          textDecoration: 'none',
                          transition: 'all 0.2s',
                          border: '1px solid transparent'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#bfdbfe';
                          e.currentTarget.style.transform = 'scale(1.1)';
                          e.currentTarget.style.borderColor = '#3b82f6';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#dbeafe';
                          e.currentTarget.style.transform = 'scale(1)';
                          e.currentTarget.style.borderColor = 'transparent';
                        }}
                      >
                        {t('test.originalText')}
                      </a>
                    )}
                    {book.video_links && (() => {
                      try {
                        const links = JSON.parse(book.video_links);
                        if (Array.isArray(links) && links.length > 0) {
                          const firstLink = links[0];
                          const linkCount = links.length;
                          return (
                            <a
                              href={firstLink}
                              target="_blank"
                              rel="noopener noreferrer"
                              title={linkCount === 1 ? t('test.viewVideo') : t('test.viewVideoMultiple', { current: 1, total: linkCount })}
                              onClick={(e) => e.stopPropagation()}
                              style={{
                                fontSize: '1rem',
                                padding: '0.2rem 0.4rem',
                                backgroundColor: '#fef3c7',
                                borderRadius: '6px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                textDecoration: 'none',
                                transition: 'all 0.2s',
                                border: '1px solid transparent',
                                position: 'relative'
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#fde68a';
                                e.currentTarget.style.transform = 'scale(1.1)';
                                e.currentTarget.style.borderColor = '#f59e0b';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#fef3c7';
                                e.currentTarget.style.transform = 'scale(1)';
                                e.currentTarget.style.borderColor = 'transparent';
                              }}
                            >
                              {t('test.videoText')}
                              {linkCount > 1 && (
                                <span style={{
                                  fontSize: '0.65rem',
                                  fontWeight: 'bold',
                                  color: '#92400e',
                                  marginLeft: '0.15rem'
                                }}>
                                  {linkCount}
                                </span>
                              )}
                            </a>
                          );
                        }
                      } catch (e) {
                        return null;
                      }
                      return null;
                    })()}
                  </div>
                  
                  {/* + 버튼 - ?�측 ?�렬 (absolute positioning) */}
                  {book.description && (
                  <button 
                    className="toggle-description-btn"
                    onClick={() => toggleDescription(book.id)}
                    style={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      margin: 0
                    }}
                    title={expandedBooks[book.id] ? t('common.close') : t('test.viewMore') || 'View more'}
                  >
                    {expandedBooks[book.id] ? '-' : '+'}
                  </button>
                  )}
                </div>
                <p><strong>{t('test.author')}:</strong> {book.author}</p>
                {book.description && expandedBooks[book.id] && (
                  <div className="book-expanded-info">
                  <p className="book-description">{book.description}</p>
                    
                    {/* ?�문 링크 */}
                    {book.original_link && (
                      <p style={{ marginTop: '0.75rem' }}>
                        <strong>{t('test.originalTextShort')}:</strong>{' '}
                        <a 
                          href={book.original_link} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          style={{
                            color: '#3b82f6',
                            textDecoration: 'underline',
                            fontWeight: '500'
                          }}
                        >
                          {t('test.viewOriginalLink')} ??
                        </a>
                      </p>
                    )}
                    
                    {/* ?�영??링크??*/}
                    {book.video_links && (() => {
                      try {
                        const links = JSON.parse(book.video_links);
                        if (Array.isArray(links) && links.length > 0) {
                          return (
                            <div style={{ marginTop: '0.75rem' }}>
                              <p style={{ marginBottom: '0.5rem' }}>
                                <strong>{t('test.relatedVideos')}:</strong>
                              </p>
                              {links.map((link, idx) => (
                                <a 
                                  key={idx}
                                  href={link} 
                                  target="_blank" 
                                  rel="noopener noreferrer"
                                  style={{
                                    display: 'inline-block',
                                    padding: '0.4rem 0.8rem',
                                    marginRight: '0.5rem',
                                    marginBottom: '0.5rem',
                                    backgroundColor: '#f3f4f6',
                                    color: '#374151',
                                    textDecoration: 'none',
                                    borderRadius: '8px',
                                    fontSize: '0.875rem',
                                    fontWeight: '500',
                                    border: '1px solid #e5e7eb',
                                    transition: 'all 0.2s'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#e5e7eb';
                                    e.currentTarget.style.transform = 'translateY(-1px)';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = '#f3f4f6';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                  }}
                                >
                                  {t('test.videoNumber', { number: idx + 1 })}
                                </a>
                              ))}
                            </div>
                          );
                        }
                      } catch (e) {
                        return null;
                      }
                      return null;
                    })()}
                  </div>
                )}
              </div>
              
              <div className="quiz-section">
                {/* v2: ?�벨�?개별 버튼 */}
                
                {/* Foundation (L1, L2) */}
                <div style={{ marginBottom: '1rem' }}>
                  <div style={{ 
                    fontSize: '0.9rem', 
                    fontWeight: '600', 
                    color: '#1e40af', 
                    marginBottom: '0.5rem',
                    textAlign: 'center'
                  }}>
                    {t('test.foundation')}
                  </div>
                  <div style={{ 
                    display: 'flex', 
                    gap: '0.5rem', 
                    justifyContent: 'center'
                  }}>
                    <button 
                      className="btn btn-secondary"
                      onClick={() => startQuizWithLevel(book.id, 'SET1_FOUNDATION', 'L1')}
                      style={{
                        padding: '0.5rem 0.8rem',
                        fontSize: '0.85rem',
                        flex: '1',
                        backgroundColor: '#dbeafe',
                        border: '2px solid #3b82f6',
                        color: '#1e40af',
                        fontWeight: '500',
                        maxWidth: '120px'
                      }}
                    >
                      {t('test.level')} 1
                    </button>
                    <button 
                      className="btn btn-secondary"
                      onClick={() => startQuizWithLevel(book.id, 'SET1_FOUNDATION', 'L2')}
                      style={{
                        padding: '0.5rem 0.8rem',
                        fontSize: '0.85rem',
                        flex: '1',
                        backgroundColor: '#dbeafe',
                        border: '2px solid #3b82f6',
                        color: '#1e40af',
                        fontWeight: '500',
                        maxWidth: '120px'
                      }}
                    >
                      {t('test.level')} 2
                    </button>
                  </div>
                </div>
                
                {/* Comprehension (L3, L4) */}
                <div style={{ marginBottom: '1rem' }}>
                  <div style={{ 
                    fontSize: '0.9rem', 
                    fontWeight: '600', 
                    color: '#92400e', 
                    marginBottom: '0.5rem',
                    textAlign: 'center'
                  }}>
                    {t('test.comprehension')}
                  </div>
                  <div style={{ 
                    display: 'flex', 
                    gap: '0.5rem', 
                    justifyContent: 'center'
                  }}>
                    <button 
                      className="btn btn-secondary"
                      onClick={() => startQuizWithLevel(book.id, 'SET2_COMPREHENSION', 'L3')}
                      style={{
                        padding: '0.5rem 0.8rem',
                        fontSize: '0.85rem',
                        flex: '1',
                        backgroundColor: '#fef3c7',
                        border: '2px solid #f59e0b',
                        color: '#92400e',
                        fontWeight: '500',
                        maxWidth: '120px'
                      }}
                    >
                      {t('test.level')} 3
                    </button>
                    <button 
                      className="btn btn-secondary"
                      onClick={() => startQuizWithLevel(book.id, 'SET2_COMPREHENSION', 'L4')}
                      style={{
                        padding: '0.5rem 0.8rem',
                        fontSize: '0.85rem',
                        flex: '1',
                        backgroundColor: '#fef3c7',
                        border: '2px solid #f59e0b',
                        color: '#92400e',
                        fontWeight: '500',
                        maxWidth: '120px'
                      }}
                    >
                      {t('test.level')} 4
                    </button>
                  </div>
                </div>
                
                {/* Transfer (L5, L6) */}
                <div style={{ marginBottom: '1rem' }}>
                  <div style={{ 
                    fontSize: '0.9rem', 
                    fontWeight: '600', 
                    color: '#9f1239', 
                    marginBottom: '0.5rem',
                    textAlign: 'center'
                  }}>
                    {t('test.transfer')}
                  </div>
                  <div style={{ 
                    display: 'flex', 
                    gap: '0.5rem', 
                    justifyContent: 'center'
                  }}>
                    <button 
                      className="btn btn-secondary"
                      onClick={() => startQuizWithLevel(book.id, 'SET3_TRANSFER', 'L5')}
                      style={{
                        padding: '0.5rem 0.8rem',
                        fontSize: '0.85rem',
                        flex: '1',
                        backgroundColor: '#fce7f3',
                        border: '2px solid #ec4899',
                        color: '#9f1239',
                        fontWeight: '500',
                        maxWidth: '120px'
                      }}
                    >
                      {t('test.level')} 5
                    </button>
                    <button 
                      className="btn btn-secondary"
                      onClick={() => startQuizWithLevel(book.id, 'SET3_TRANSFER', 'L6')}
                      style={{
                        padding: '0.5rem 0.8rem',
                        fontSize: '0.85rem',
                        flex: '1',
                        backgroundColor: '#fce7f3',
                        border: '2px solid #ec4899',
                        color: '#9f1239',
                        fontWeight: '500',
                        maxWidth: '120px'
                      }}
                    >
                      {t('test.level')} 6
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      
      <div className="info-section">
        <div className="card">
          <h3>{t('test.gameGuide')}</h3>
          <ul>
            <li>{t('test.guideLoggedIn')}</li>
            <li>{t('test.guideGuest')}</li>
            <li>{t('test.guideCompletion')}</li>
            <li>{t('test.guideLearning')}</li>
            <li>{t('test.guideRetry')}</li>
          </ul>
        </div>
      </div>

      {searchParams.get('bookId') && (
        <div style={{ display: 'flex', justifyContent: 'center', margin: '28px 0' }}>
          <Link to="/test" className="btn btn-primary">{t('test.viewAllBooks')}</Link>
        </div>
      )}
    </div>
  );
};

export default TestPage; 
